//import './carrito.css'
import { useEffect, useState } from "react";
import {
    decodeNombreProductoURL, moneda_mostrar, renderNumero, RutaProductos,
    ConsultaData, RutaLocal, isSession,ENDPOINT
} from '../componentes/funcionesEspeciales';
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import moment from "moment"
import swal from 'sweetalert'
import socketIOClient from "socket.io-client";

import Card from '../styles/cardPollo.module.css';

function Carrito({ agregarItemCarro, quitarItemCarro, limpiarCarro, }) {
    const [productosCarrito, setProductosCarrito] = useState(localStorage.getItem('carrito'));
    const [productosRenderizar, setProductosRenderizar] = useState([])
    const [cantidades_permitidas, setCantidadesPermitidas] = useState({
        minimo: 1,
        maximo: 10,
        step: 1
    })
    const [optionsCantidades, setOptionsCantidades] = useState([])
    const eliminarItemCarro = (cartItem) => {
        let productos_carro = [...productosRenderizar]
        //seteando el arreglo del carro temp de esta pantalla
        let existingProducto = productos_carro.findIndex(
            (item) => item.producto.id === cartItem.id
        )
        productos_carro.splice(existingProducto, 1)
        if (productos_carro.length == 0) {
            setError({
                icono: '',
                texto: "No tienes productos en el carrito!"
            })
        }
        setProductosRenderizar(productos_carro)
        quitarItemCarro(cartItem);
    }
    const manejarCantidad = (e, item, index) => {
        console.log(item, e.target.value)
        agregarItemCarro(item, e.target.value)
        //seteando el arreglo del carro temp de esta pantalla
        let prodcutos_carro = [...productosRenderizar]
        prodcutos_carro[index].cantidad = e.target.value
        setProductosCarrito(JSON.stringify(prodcutos_carro))
    }
    const [error, setError] = useState({
        icono: '',
        texto: ''
    })
    useEffect(() => {
        //console.log("tas loco", localStorage.getItem('carrito'))
        //console.log("de arranque", productosCarrito, productosCarrito.length)
        if (productosCarrito == null || productosCarrito == "" || productosCarrito.length == 2) { //2 porque es el string '[]'
            setError({
                icono: '',
                texto: "No tienes productos en el carrito!"
            })
        } else {
            //console.log("que tengo", JSON.parse(productosCarrito))
            setProductosRenderizar(JSON.parse(productosCarrito))
            let opciones = []
            for (var i = cantidades_permitidas.minimo; i <= cantidades_permitidas.maximo; i = i + cantidades_permitidas.step) {
                let option = {
                    value: i,
                    label: i
                }
                opciones.push(option)
            }
            setOptionsCantidades(opciones)
        }
        getSucursales()
        getDistritos()
    }, [])
    //}, [productosCarrito])
    //para realizar el pedido
    const [contacto, setContacto] = useState({
        nombres_completos: '',
        numero_contacto: '',
        numero_documento: '',
        ruc: '',
        mensaje_referencial: '',
        id_sucursal: 1,
        id_departamento: 4,
        id_provincia: 4,
        id_distrito: 0,
        nombre_departamento: 'AREQUIPA',
        nombre_provincia: 'AREQUIPA',
        nombre_distrito: '',
        direccion: '',
        tipo_documento: 'boleta',
        direccion_pedido: '',
        costo_envio: 0,
        tipo_pago: '',
    })
    const manejadorContacto = (e) => {
        const { name, value } = e.target
        setContacto({
            ...contacto,
            [name]: value
        })
    }
    const [sucursales, setSucursales] = useState([])
    const getSucursales = () => {
        ConsultaData('?/web/getSucursales').then(response => { setSucursales(response) })
    }
    const [departamentos, setDepartamentos] = useState([])
    const [provincias, setProvincias] = useState([])
    const [distritos, setDistritos] = useState([])
    const getDistritos = () => {
        ConsultaData('?/web/getDistritos').then(response => { setDistritos(response) })
    }

    const [modalDireccion, setModalDireccion] = useState(false)
    const cerrarModalDireccion = () => {
        if (contacto.id_distrito == 0 || contacto.direccion == "") {
            swal({
                icon: "warning",
                title: "Direccion de envío no consignado",
                text: "Por favor Complete Distrito y Dirección",
            });
            setModalDireccion(false)
            return
        }
        setContacto({
            ...contacto,
            costo_envio: calcularCostoEnvio(),
            nombre_distrito: distritos.find(d => d.idDist == contacto.id_distrito).distrito
        })
        setModalDireccion(false)
    }
    const calcularCostoEnvio = () => {
        let costo_envio = 0
        if (contacto.id_distrito > 0) {
            costo_envio = parseFloat(distritos.find(d => d.idDist == contacto.id_distrito).costo_envio || 0)
        }
        return costo_envio
    }
    const abrirModalDireccion = () => setModalDireccion(true);

    const [modalPedido, setModalPedido] = useState(false);
    const cerrarModalPedido = () => setModalPedido(false);
    const [cargando, setCargando] = useState(false);
    const abrirModalPedido = () => {
        setCargando(true)
        if (contacto.nombres_completos == "") {
            isSession().then(response => {
                //console.log("asdasdasd", response)
                if (response["response"]) {
                    setContacto({
                        ...contacto,
                        nombres_completos: response.nombres_completos,
                        numero_contacto: response.celular,
                        numero_documento: response.dni,
                        id: response.id
                    })
                    setModalPedido(true)
                } else {
                    //pedir que se registre o inicie sesion
                    swal({
                        icon: "warning",
                        title: "Debe iniciar sesion para realizar el pedido",
                        text: "Por favor inicie sesion o registrese para poder realizar el pedido",
                    });
                }
                setCargando(false)
                return
            })
        } else {
            setModalPedido(true)
            setCargando(false)
        }

        return
        if (contacto.id_distrito == 0) {
            swal({
                icon: "error",
                title: "Direccion de envío no consignado",
                text: "Por favor calcule su Costo de Envío para proceder con la compra",
            });
            return
        }
        setModalPedido(true)
    };
    const validarPedido = () => {
        if (contacto.numero_documento.toString().trim().length != 8) {
            alert("DNI debe tener 8 dígitos")
            return false
        }
        if (contacto.numero_contacto.toString().trim().length != 9) {
            alert("Celular debe tener 9 dígitos No use codigo pais +51")
            return false
        }
        if (contacto.tipo_pago == "") {
            alert("Seleccione tipo de pago preferido")
            return false
        }
        return true
    }
    const realizarPedido = () => {
        if (!validarPedido()) {
            return
        }
        if (!window.confirm("Confirmar los datos con el pedido")) {
            return
        }
        //console.log("enviando", { cliente: contacto, items: JSON.parse(productosCarrito) })
        //return
        //console.log("enviandoooooooooooooooo");
        ConsultaData('?/web/guardarPedido', {
            cliente: contacto,
            pedido: {
                fecha_registro: moment().format("YYYY-MM-DD"),
                fecha_emision: moment().format("YYYY-MM-DD"),
                id_sucursal: contacto.id_sucursal,
                tipo_documento: contacto.tipo_documento,
                id_moneda: 12,
                id_tipo_pago: 16,
                dias_validez: 3,
                estado_registro: 1,
                direccion_pedido: contacto.direccion_pedido,
                tipo_cambio: 1.000,
                tipo_pago: contacto.tipo_pago,
                ruc: contacto.ruc,
                id_venta: 0,
                total_pedido: (productosRenderizar.reduce((a, b) => a + parseFloat(b.producto.precio_venta * b.cantidad), 0)) + contacto.costo_envio
            },
            items: JSON.parse(productosCarrito)
            //items: productosCarrito
        }, 'post').then(response => {
            //console.log(response)
            if (response["response"]) {
                swal({
                    title: 'Pedido Registrado Con éxito',
                    text: 'Gracias por realizar tu pedido, en unos momentos nos contacteremos contigo para coordinar la entrega,' +
                        'por favor guarda el código de pedido: [ PEDIDO COD ' + response["getID"] + ' ]',
                    icon: 'success',
                    confirmButtonText: 'OK',
                }).then((result) => {
                    limpiarCarro()
                    window.open(RutaLocal, "_self");
                })
                const socket = socketIOClient(ENDPOINT, { transports: ['websocket'] });
                socket.emit("nuevoPedidoWeb", response["getID"]);
            } else {
                swal("Disculpa no pudimos registrar tu pedido, por favor recargar la página e intenta de nuevo", {
                    title: 'Error',
                    buttons: false,
                    timer: 10000,
                    icon: 'error'
                });
            }
            cerrarModalPedido()
        })
    }

    return (
        <div className="" >
            <div className="d-flex flex-column flex-sm-row gap-0">
                <div className="flex-grow-1 border-start border-top">
                    <div className=""  >
                        <div className="border-bottom">
                            <h5 className="p-3 national-bold">Carrito de compras</h5>
                        </div>
                        <div className="">
                            <div className="alert alert-warning col-12" style={error.texto != "" ? {} : { display: "none" }}>
                                <span className="icon icon-alert">{error.icono}</span>
                                <div className="alert-important-text"> {error.texto}
                                </div>
                            </div>
                            {/* {JSON.stringify(productosRenderizar)} */}
                            {/* {JSON.stringify(productosCarrito)} */}

                            {productosRenderizar.map((item, index) => (
                                <div className="p-3 px-0 border-bottom" key={index}>
                                    <div className="">
                                        <div className="d-flex flex-row">
                                            <div className={`${Card.cardPollo} image-container`} style={{ maxWidth: '160px' }}>
                                                <a href={"/producto/" + decodeNombreProductoURL(item.producto.nombre)}>
                                                    <img src={item.producto.imagen == "" ? "https://i.imgur.com/m7A8LhG.jpg" : RutaProductos + item.producto.imagen}
                                                        alt={item.producto.nombre} className="w-100" />
                                                </a>
                                            </div>
                                            <div className="flex-fill ml-2 ml-md-4 d-flex flex-column gap-4">
                                                <div className="d-flex flex-row justify-content-between align-items-start gap-4">
                                                    <h5 className="mt-1">
                                                        <a href={"/producto/" + decodeNombreProductoURL(item.producto.nombre)}>{item.producto.nombre}</a>
                                                    </h5>
                                                    <div className="d-flex flex-column align-items-center">
                                                        <span type="button" className='bg-white pointer text-danger fw-normal' onClick={(e) => eliminarItemCarro(item.producto)}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash3" viewBox="0 0 16 16">
                                                                <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
                                                            </svg>
                                                        </span>
                                                        <small className="d-none d-md-block" style={{ color: '#00000065' }}>Eliminar</small>
                                                    </div>

                                                </div>
                                                <div className="d-flex flex-column gap-3 mt-auto">
                                                    <small className="text-muted position-absolute ml-2" style={{ marginTop: '6px' }}>Cantidad:</small>
                                                    <select className="form-control form-control-sm text-end bg-transparent" style={{ maxWidth: '100px' }} value={item.cantidad} onChange={(e) => { manejarCantidad(e, item.producto, index) }}>
                                                        {
                                                            optionsCantidades.map((option, key) => (
                                                                <option key={key} value={option.value}>
                                                                    {option.label}
                                                                </option>
                                                            ))
                                                        }
                                                    </select>
                                                    <h4 className="text-danger">
                                                        P. U.   {"  " + moneda_mostrar} {renderNumero(item.producto.precio_venta)}
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            ))}

                        </div>
                    </div>
                </div>

                <div className="cart-summary-section col-md-4 col-sm-6 col-12 border ">
                    <div className="contenedor_recuento sticky-top" style={{ top: '70px' }}>
                        <h5 className="py-3  national-bold">Resumen de tu Pedido</h5>
                        <ul className="recuento py-3">
                            {productosRenderizar.map((item, key) => (
                                <li className="d-flex">
                                    <p>{item.producto.nombre} ({item.cantidad})</p>
                                    <span className="price-main-sm float-right subtotal-price ml-auto text-right">
                                        {moneda_mostrar} {renderNumero(item.producto.precio_venta * item.cantidad)}
                                    </span>
                                </li>
                            ))}

                            <li className="d-flex">
                                <p>Subtotal ({productosRenderizar.reduce((a, b) => a + parseFloat(b.cantidad), 0)})</p>
                                <span className="price-main-sm float-right subtotal-price ml-auto text-right">
                                    {moneda_mostrar} {renderNumero(productosRenderizar.reduce((a, b) => a + parseFloat(b.producto.precio_venta * b.cantidad), 0))}
                                </span>
                            </li>
                            {/* <li className="d-flex" >
                                <p>Envío</p>
                                <span className=" float-right ml-auto" >S/ 7.90</span>
                                <span className=" float-right ml-auto ">Envío gratis</span>
                            </li> */}

                            {/* <li  className="d-flex ">
                                <p>Descuento</p>
                                <span className="price-light-md float-right ml-auto">-S/ 0.00</span>
                            </li> */}

                            <li>
                                {/* {contacto.id_distrito == 0 ?
                                    <>
                                        <p><a className="sm btn-sm btn btn-secondary " onClick={abrirModalDireccion}>Calcular envío</a></p>
                                    </>
                                    :
                                    <div className="">
                                        <span>{contacto.nombre_departamento + "-" + contacto.nombre_provincia + "-" + contacto.nombre_distrito}</span>
                                    </div>
                                } */}
                            </li>
                            {/* <li className="summary-partnership d-flex " >
                                <p></p>
                                <span className=" float-right ml-auto">-S/ 0.00</span>
                            </li> */}
                            {contacto.id_distrito != 0 &&
                                <li className="d-flex ">
                                    <p>Envío</p>
                                    <span className="price-light-md float-right ms-auto">
                                        {contacto.costo_envio == 0 ? "Envío gratis" : "S/ " + contacto.costo_envio.toFixed(2)}
                                    </span>
                                </li>
                            }

                            <ul className="seccion_pagar">
                                <li className="summary-total">
                                    <h4 className="d-flex align-items-end">
                                        <h5>
                                            Total&nbsp;
                                        </h5>
                                        <h4 className="precio_pagar ms-auto" >
                                            {moneda_mostrar} {renderNumero((productosRenderizar.reduce((a, b) => a + parseFloat(b.producto.precio_venta * b.cantidad), 0)) + contacto.costo_envio)}
                                        </h4>
                                    </h4>
                                </li>
                                <br />
                                <li className="">
                                    <div className="btn btn-sm col-md-12" >
                                        <button onClick={abrirModalPedido} className="btn" disabled={cargando && modalPedido}>Procesar Pedido</button>
                                    </div>
                                </li>
                            </ul>
                        </ul>
                    </div>
                    <Modal show={modalPedido} onHide={cerrarModalPedido} size="lg" style={{ zIndex: "9999" }}>
                        <Modal.Header closeButton>
                            <Modal.Title>Confirmación de Pedido</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Por favor complete los siguientes datos, Nos contactaremos con usted en el breve plazo.
                            <hr />
                            {/* ESTO SOLO ES PARA MISSTITIENDA!! */}
                            <div className="row form-group" style={{ display: "none" }}>
                                <label className="control-label col-md-4">Tienda</label>
                                <div className="col-md-8">
                                    <select className="form-control " name="id_sucursal" value={contacto.id_sucursal} onChange={manejadorContacto} >
                                        {sucursales.map((item, key) => (
                                            <option key={key} value={item.id}>{item.nombre + " " + item.direccion}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <br />
                            {/* ACABA DE MISTITIENDA */}
                            <div className="row form-group" >
                                <label className="control-label col-md-4">Tipo Comprobante</label>
                                <div className="col-md-8">
                                    <select className="form-control " name="tipo_documento" value={contacto.tipo_documento} onChange={manejadorContacto} >
                                        <option value={"boleta"}>Boleta</option>
                                        <option value={"factura"}>Factura</option>
                                    </select>
                                </div>
                            </div>
                            <br />
                            {contacto.tipo_documento == "factura" &&
                                <><div className="row form-group" >
                                    <label className="control-label col-md-4">RUC</label>
                                    <div className="col-md-8">
                                        <input maxLength="11" type="text" className="form-control " name="ruc"
                                            value={contacto.ruc} placeholder="RUC" onChange={manejadorContacto} />
                                    </div>
                                </div>
                                    <br />
                                </>
                            }
                            <div className="row form-group">
                                <label className="control-label col-md-4">DNI:</label>
                                <div className="col-md-8">
                                    <input maxLength="15" type="text" className="form-control " name="numero_documento"
                                        value={contacto.numero_documento} placeholder="Numero Documento" onChange={manejadorContacto} />
                                </div>
                            </div>
                            <br />
                            <div className="row form-group">
                                <label className="control-label col-md-4">Nombres Completos <span className='obligatorio'>*</span></label>
                                <div className="col-md-8">
                                    <input maxLength="100" type="text" className="form-control " name="nombres_completos" disabled
                                        value={contacto.nombres_completos} placeholder="Denominacion" onChange={manejadorContacto} />
                                </div>
                            </div>
                            <br />
                            <div className="row form-group">
                                <label className="control-label col-md-4">Número Celular <span className='obligatorio'>*</span></label>
                                <div className="col-md-8">
                                    <input maxLength="30" type="text" className="form-control " name="numero_contacto"
                                        value={contacto.numero_contacto} placeholder="Prefencialmente WhatsApp" onChange={manejadorContacto} />
                                </div>
                            </div>
                            <br />
                            <div className="row form-group">
                                <label className="control-label col-md-4">Tipo Pago Preferido</label>
                                <div className="col-md-8">
                                    <select className="form-control " name="tipo_pago" value={contacto.tipo_pago} onChange={manejadorContacto} >
                                        <option>Seleccione</option>
                                        <option value={"Efectivo"}>Efectivo</option>
                                        <option value={"Yape/Plin/Billetera Dig"}>Yape/Plin/Billetera Dig</option>
                                        <option value={"Deposito"}>Deposito</option>
                                        <option value={"Transferencia"}>Transferencia</option>
                                        <option value={"Tarjeta"}>Tarjeta</option>

                                    </select>
                                </div>
                            </div>
                            <br />
                            <div className="row form-group">
                                <label className="control-label col-md-4">Dirección del Pedido</label>
                                <div className="col-md-8">
                                    <textarea className="form-control " name="direccion_pedido" value={contacto.direccion_pedido} onChange={manejadorContacto} >
                                    </textarea>
                                </div>
                            </div>
                            <br />
                            <div className="row form-group">
                                <label className="control-label col-md-4">Mensaje Referencial</label>
                                <div className="col-md-8">
                                    <textarea className="form-control " name="mensaje_referencial" value={contacto.mensaje_referencial} onChange={manejadorContacto} >
                                    </textarea>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button className="secondary btn-secondary btn btn-sm" onClick={cerrarModalPedido}>
                                Volver al Carrito
                            </Button>
                            <Button className="btn-primary btn btn-sm" onClick={realizarPedido}>
                                Realizar Pedido
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    <Modal show={modalDireccion} onHide={cerrarModalDireccion} size="md">
                        <Modal.Header closeButton>
                            <Modal.Title>Información de tu Dirección</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Por favor llene sus datos su Distrito y  Dirección exacta
                            <div className="row form-group">
                                <label className="control-label col-md-4">Departamento</label>
                                <div className="col-md-8">
                                    <select className="form-control " name="id_departamento" value={contacto.id_departamento} onChange={manejadorContacto} >
                                        {/* {departamentos.map((item, key) => (
                                            <option key={key} value={item.id}>{item.nombre + " " + item.direccion}</option>
                                        ))} */}
                                        <option value={4}>{"AREQUIPA"}</option>
                                    </select>
                                </div>
                            </div>
                            <br />
                            <div className="row form-group">
                                <label className="control-label col-md-4">Provincia</label>
                                <div className="col-md-8">
                                    <select className="form-control " name="id_provincia" value={contacto.id_provincia} onChange={manejadorContacto} >
                                        {/* {provincias.map((item, key) => (
                                            <option key={key} value={item.id}>{item.nombre + " " + item.direccion}</option>
                                        ))} */}
                                        <option value={35}>{"AREQUIPA"}</option>
                                    </select>
                                </div>
                            </div>
                            <div className="row form-group">
                                <label className="control-label col-md-4">Distrito</label>
                                <div className="col-md-8">
                                    <select className="form-control " name="id_distrito" value={contacto.id_distrito} onChange={manejadorContacto} >
                                        <option value={0}>{"Seleccione"}</option>
                                        {distritos.map((item, key) => (
                                            <option key={key} value={item.idDist}>{item.distrito}</option>
                                        ))}
                                        {/* <option value={35}>{"AREQUIPA"}</option> */}
                                    </select>
                                </div>
                            </div>
                            <div className="row form-group">
                                <label className="control-label col-md-4">Dirección</label>
                                <div className="col-md-8">
                                    <textarea className="form-control " name="direccion" value={contacto.direccion} onChange={manejadorContacto} >
                                    </textarea>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={cerrarModalDireccion}>
                                Actualizar Direccion
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>
        </div>
    );
}

export default Carrito;